import styled from 'styled-components'

type ContainerProps = {
  documentView: boolean
  expandedView: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${props => (props.documentView ? '1rem' : '2rem')};
  text-align: center;
  border-radius: 25px;
  margin: ${props => (props.documentView ? '0' : '6rem auto')};
  ${props => (props.documentView ? '' : 'grid-column: 3 / span 2;')}
  background-color: white;
  ${props => (props.expandedView ? '' : 'box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8)')};

  ${props => (props.documentView ? 'width: 18rem; height: 14rem;' : '')}// max-width: 30%;
  // min-height: 40%;
   @media(max-width:768px){
      width:100%;
    }
`
export const ListContainer = styled.div<ContainerProps>`
  
  min-width:${props => (props.expandedView ? '18rem;' : '100%;')} 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${props => (props.documentView ? '1rem' : '2rem')};
  text-align: center;
  border-radius: 25px;
  margin: ${props => (props.documentView ? '0' : '6rem auto')};
  ${props => (props.documentView ? '' : 'grid-column: 3 / span 2;')}
  background-color: white;
  ${props => (props.expandedView ? '' : 'box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8)')};

  ${props => (props.documentView ? 'width: 18rem; height: 14rem;' : '')}// max-width: 30%;
  // min-height: 40%;

`

type DropAreaProps = {
  documentView: boolean
  hasUploaded?: boolean
  expandedView: boolean
}

export const DropArea = styled.div<DropAreaProps>`
  cursor: ${props => (props.hasUploaded ? 'default' : 'pointer')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  text-align: center;
  border: ${props =>
    props.hasUploaded || (props.documentView && !props.expandedView) ? 'none' : '1px gray dashed'};
  border-radius: 10px;
  margin: ${props => (props.documentView ? 'auto' : '2rem auto')};
  //margin: 2rem auto;
  //grid-column: 3 / span 2;

  // max-width: 30%;
  // min-height: 40%;
  @media(max-width:768px){
      width:100%;
    }
`
export const Link = styled.a`
  margin-top: 1rem;

  font-family: 'Inter';
  font-size: 14px;
  max-width: 100%;
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  background-color: #2d60ff;
  border: none;
  border-radius: 10px;
  outline: 0;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  :hover {
    opacity: 0.8;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`

export const Text1 = styled.p`
  margin-top: 1rem;
  color: black;

  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`
export const Text2 = styled.p`
  margin-top: 1rem;
  color: #7d7d7d;

  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`
